import { createRule } from './common'
import { EXACT_LENGTH_ERROR } from './errorMessages'

export default length => {
  const errorMessage = EXACT_LENGTH_ERROR.replace('{length}', length || '')
  const isValid = value => value.toString().length === length

  return createRule({ isValid, errorMessage })
}
